








import { Component,  Vue } from 'vue-property-decorator'; 
import Vue2Filters from 'vue2-filters'
import {mapState} from 'vuex'
import { Action } from 'vuex-class'
import Header from '@/components/Header.vue';
import WineBox from '@/components/WineBox.vue';

Vue.use(Vue2Filters)

@Component({
  components: {
    Header, WineBox
  },
   computed: mapState([ 
    'wineBox',
  ]),
  
})
export default class App extends Vue {}
